export default {
  dev: {
    admin: 'https://skordev.com/admin-dashboard/#/report',
    app: 'https://skordev.com/',
    basePath: 'https://pru-rewards.skordev.com/#/',
    img: 'https://skordev.com',
    externalAuthUrl: 'https://authenticate-me-uat.prudential.com.sg/login',
    ascendUrl: 'https://pru-rewards-ascend.skordev.com',
    opusUrl: 'https://pru-rewards-opus.skordev.com',
  },
  prod: {
    admin: 'https://cerrapoints.com/admin-dashboard/#/report',
    app: 'https://cerrapoints.com/',
    basePath: 'https://prurewards.prudential.com.sg/#/',
    img: 'https://cerrapoints.com',
    externalAuthUrl: 'https://authenticate-me.prudential.com.sg/login',
    ascendUrl: 'https://ascend.prurewards.prudential.com.sg/',
    opusUrl: 'https://opus.prurewards.prudential.com.sg/',
  },
};
